/** Live **/
export const Gateway = 'https://servicing-gateway.amigoloans.ie';
export const Website = 'https://www.amigoloans.ie';
export const AppInsightsInstrumentationKey = "7d9bb63d-7f6a-4e51-9955-eb90679a5599";

/** UAT **/
//export const Gateway = 'https://servicing-gateway-amigoie-uat.azurewebsites.net';
//export const Website = 'https://amigoie-uat.azurewebsites.net';
//export const AppInsightsInstrumentationKey = "b7f9023a-2916-49f1-8d0a-e802a3628acc";

/** DEV **/
//export const Gateway = 'https://servicing-gateway-amigoie-dev.azurewebsites.net';
//export const Website = 'https://amigoie-dev.azurewebsites.net';

/** localhost **/
//export const Gateway = 'https://localhost:44315';


// WEBPACK FOOTER //
// ./src/BaseUrl.js